
var stache = require('can/view/stache/stache');
module.exports = stache("<script async='async' src='https://www.googletagservices.com/tag/js/gpt.js'></script>\r\n<div id='{{optDiv}}' class=\"c-dfp-advert-unit\"></div>\r\n");